"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var boolean_serialiser_1 = require("./../serialisers/boolean-serialiser");
var integer_serialiser_1 = require("./../serialisers/integer-serialiser");
var missing_topic_request_serialiser_1 = require("./../services/missing-topic/missing-topic-request-serialiser");
var remove_topic_serialiser_1 = require("./../services/remove-topic/remove-topic-serialiser");
var topic_add_request_serialiser_1 = require("./../services/topic-add/topic-add-request-serialiser");
var topic_add_response_serialiser_1 = require("./../services/topic-add/topic-add-response-serialiser");
exports.MISSING_TOPIC = {
    id: 50,
    request: missing_topic_request_serialiser_1.MissingTopicRequestSerialiser,
    response: boolean_serialiser_1.BooleanSerialiser
};
exports.TOPIC_REMOVAL = {
    id: 83,
    request: remove_topic_serialiser_1.RemoveTopicSerialiser,
    response: integer_serialiser_1.IntegerSerialiser
};
exports.TOPIC_ADD = {
    id: 112,
    request: topic_add_request_serialiser_1.TopicAddRequestSerialiser,
    response: topic_add_response_serialiser_1.TopicAddResponseSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-control-services.js
// module id = 1387
// module chunks = 1